var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddressBook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 2c-.8273 0-1.5.6727-1.5 1.5v9c0 .8273.6727 1.5 1.5 1.5h6.75c.8273 0 1.5-.6727 1.5-1.5v-9c0-.8273-.6727-1.5-1.5-1.5zM6.5 8.75H8c1.036 0 1.875.839 1.875 1.875A.376.376 0 0 1 9.5 11H5a.376.376 0 0 1-.375-.375c0-1.036.839-1.875 1.875-1.875M5.75 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m7.875-2.625a.376.376 0 0 0-.375-.375.376.376 0 0 0-.375.375v1.5a.376.376 0 0 0 .375.375.376.376 0 0 0 .375-.375zM13.25 6.5a.376.376 0 0 0-.375.375v1.5a.376.376 0 0 0 .375.375.376.376 0 0 0 .375-.375v-1.5a.376.376 0 0 0-.375-.375m.375 3.375a.376.376 0 0 0-.375-.375.376.376 0 0 0-.375.375v1.5a.376.376 0 0 0 .375.375.376.376 0 0 0 .375-.375z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddressBook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/address-book.3f4da6af5371a58e206c83614ddf5764.svg";